import React from 'react';

import TalkListItem from './TalkListItem'

import styles from './TalkList.sass';

export default ({talks, ...props}) =>
    <ul className={styles.root} {...props}>
        {talks.map(talk => <TalkListItem key={talk.slug} talk={talk}/>)}
    </ul>;


// WEBPACK FOOTER //
// ./src/modules/People/elements/TalkList.js